import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// This file contains i18n Language translation configuration

const options = {
  addPath: "/locales/{{lng}}/{{ns}}.json",
  loadPath: "/locales/{{lng}}/{{ns}}.json",
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: options,
    debug: false,
    defaultNS: "common",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    ns: ["common"],
    saveMissing: true,
  });

export { i18n };
